export const buildApiKeyApprovalPayload = (item, companies, selectableCountries) => {
  const companyName = String(item.reported_company_name || item.company_name || '').trim()
  const candidates = companies.filter((company) => (
    !company.is_deleted && String(company.name || '').trim().toLowerCase() === companyName.toLowerCase()
  ))
  const reportedCountry = String(item.reported_company_country || '').trim().toUpperCase()
  const companyCountry = reportedCountry || (
    candidates.length === 1 ? String(candidates[0].country || '').trim().toUpperCase() : ''
  )
  const matches = candidates.filter((company) => (
    String(company.country || '').trim().toUpperCase() === companyCountry
  ))
  const siteName = String(item.reported_site_name || item.site_name || '').trim()
  if (!companyName || !selectableCountries.includes(companyCountry) || !siteName || matches.length > 1) return null
  return {
    ...(matches.length === 1
      ? { company_id: matches[0].company_id }
      : { company_name: companyName, company_country: companyCountry }),
    site_name: siteName
  }
}
